module.exports = __webpack_public_path__ + "a62885c2c38d281acf86772b72eb9278.svg";